<template>
  <div class="admin-room-container figma-property-page">
    <div class="figma-white-card">
      <div class="figma-page-header">
        <div class="figma-page-title">{{ $t('userManagement.pageTitle') }}</div>
        <div class="figma-header-divider"></div>
        <div class="figma-header-row">
          <div class="figma-btn-group">
            <el-button size="small" class="figma-btn-add" @click="_openAddDialog">
              <img src="/assets/CodeBuddyAssets/914_10296/25.svg" class="btn-icon" />
              <span>{{ $t('userManagement.action.add') }}</span>
            </el-button>
            <el-button size="small" class="figma-btn-refresh" title="刷新" @click="_queryMethod">
              <img src="/assets/CodeBuddyAssets/914_10296/24.svg" class="btn-icon" />
            </el-button>
          </div>
          <div class="figma-search-group">
            <el-input size="small" v-model="conditions.telLike"
              :placeholder="$t('userManagement.search.phonePlaceholder')" class="figma-search-input" clearable
              @keyup.enter.native="_queryMethod" />

            <el-input size="small" v-model="conditions.keyword"
              :placeholder="$t('userManagement.search.keywordPlaceholder')" class="figma-search-input" clearable
              @keyup.enter.native="_queryMethod" />
            <el-select size="small" v-model="conditions.roleName"
              :placeholder="$t('userManagement.search.roleGroupPlaceholder')" class="figma-search-select"
              clearable filterable>
              <el-option v-for="item in roleGroupOptions" :key="item.value"
                :label="item.label" :value="item.label" />
            </el-select>
            <el-button size="small" class="figma-btn-search" @click="_queryMethod">
              <img src="/assets/CodeBuddyAssets/914_10296/22.svg" class="btn-icon" />
              <span>{{ $t('common.search') }}</span>
            </el-button>
          </div>
        </div>
      </div>

      <div class="figma-table-section">
        <el-table :data="tableData" style="width: 100%" :header-cell-style="headerCellStyle" :cell-style="cellStyle">
          <el-table-column prop="userId" :label="$t('userManagement.table.id')" min-width="80" align="center" />
          <el-table-column prop="name" :label="$t('userManagement.table.name')" min-width="100" align="center">
            <template slot-scope="scope">{{ scope.row.name || '-' }}</template>
          </el-table-column>
          <el-table-column prop="sex" label="性别" min-width="80" align="center">
            <template slot-scope="scope">{{ scope.row.sex === '1' ? '男' : scope.row.sex === '0' ? '女' : '-' }}</template>
          </el-table-column>
          <el-table-column prop="roles" :label="$t('userManagement.table.roleGroup')" min-width="120" align="center">
            <template slot-scope="scope">{{ getRoleNames(scope.row.roles) }}</template>
          </el-table-column>
          <el-table-column prop="communityNames" :label="$t('userManagement.table.communityNames')" min-width="120" align="center">
            <template slot-scope="scope">{{ scope.row.communityNames || '-' }}</template>
          </el-table-column>
          <el-table-column prop="createTime" :label="$t('userManagement.table.createTime')" min-width="160" align="center">
            <template slot-scope="scope">{{ scope.row.createTime || '-' }}</template>
          </el-table-column>
          <el-table-column prop="tel" :label="$t('userManagement.table.phone')" min-width="130" align="center">
            <template slot-scope="scope"><span class="figma-phone">{{ scope.row.tel || '-' }}</span></template>
          </el-table-column>
          <el-table-column prop="statusName" :label="$t('userManagement.table.status')" min-width="100" align="center">
            <template slot-scope="scope">
              <span :class="['status-tag', getStatusClass(scope.row.status)]">{{ getStatusName(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="lastLoginIp" :label="$t('userManagement.table.lastLogin')" min-width="160" align="center">
            <template slot-scope="scope">{{ scope.row.lastLoginIp || '-' }}</template>
          </el-table-column>
          <el-table-column prop="lastLoginTime" :label="$t('userManagement.table.lastLoginTime')" min-width="160" align="center">
            <template slot-scope="scope">{{ scope.row.lastLoginTime || '-' }}</template>
          </el-table-column>
          <el-table-column :label="$t('userManagement.table.operation')" fixed="right" min-width="120" align="center">
            <template slot-scope="scope">
              <span class="action-links">
                <a class="action-link" @click="_openEditDialog(scope.row)">{{ $t('userManagement.action.edit') }}</a>
                <span class="link-separator"></span>
                <a class="action-link action-link-danger" @click="_deleteRow(scope.row)">{{ $t('userManagement.action.delete') }}</a>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="figma-pagination">
        <span class="pagination-total">共{{ pagination.total }}条</span>
        <el-pagination :current-page="pagination.current" :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.size" layout="prev, pager, next, jumper" :total="pagination.total"
          @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        <el-select v-model="pagination.size" size="small" class="pagination-size-select">
          <el-option label="10条/页" :value="10" /><el-option label="20条/页" :value="20" /><el-option label="50条/页" :value="50" />
        </el-select>
      </div>
    </div>

    <!-- 新增弹窗 -->
    <el-dialog :visible.sync="addDialogVisible" width="650px" :show-close="false"
      custom-class="figma-edit-dialog" @close="_resetAddForm">
      <div slot="title" class="figma-dialog-header">
        <span class="figma-dialog-title">{{ $t('userManagement.add.title') }}</span>
        <img src="/assets/CodeBuddyAssets/914_10296/26.svg" class="dialog-divider" />
      </div>
      <el-form ref="addForm" :model="addForm" :rules="addRules" label-width="84px"
        class="figma-edit-form" size="small">
        <el-form-item :label="$t('userManagement.add.roleGroup') + ':'" prop="roleId" required>
          <el-select v-model="addForm.roleId" :placeholder="$t('userManagement.add.roleGroupPlaceholder')"
            class="figma-form-input" clearable @change="handleAddRoleChange">
            <el-option v-for="item in roleGroupOptions" :key="item.value"
              :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="isAddDistrictHousingBureauRole" :label="isAddCityHousingBureauRole ? '省市:' : '省市区:'" prop="provinceCode" required>
          <div class="area-cascader-row">
            <el-select v-model="addForm.provinceCode" placeholder="请选择省"
              class="area-cascader-select" clearable @change="handleAddProvChange">
              <el-option v-for="item in areaOptions.provs" :key="item.areaCode"
                :label="item.areaName" :value="item.areaCode" />
            </el-select>
            <el-select v-model="addForm.cityCode" placeholder="请选择市"
              class="area-cascader-select" clearable :disabled="!addForm.provinceCode"
              @change="handleAddCityChange">
              <el-option v-for="item in areaOptions.citys" :key="item.areaCode"
                :label="item.areaName" :value="item.areaCode" />
            </el-select>
            <el-select v-if="!isAddCityHousingBureauRole" v-model="addForm.districtCode" placeholder="请选择区"
              class="area-cascader-select" clearable :disabled="!addForm.cityCode"
              @change="handleAddAreaChange">
              <el-option v-for="item in areaOptions.areas" :key="item.areaCode"
                :label="item.areaName" :value="item.areaCode" />
            </el-select>
          </div>
        </el-form-item>
        <el-form-item v-if="showAddCommunitySelect" :label="$t('userManagement.add.community') + ':'" prop="communityIds" required>
          <el-select v-model="addForm.communityIds" :placeholder="$t('userManagement.add.communityPlaceholder')"
            class="figma-form-input" clearable multiple filterable>
            <el-option v-for="item in communityOptions" :key="item.value"
              :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('userManagement.add.name') + ':'" prop="name" required>
          <el-input v-model="addForm.name" :placeholder="$t('userManagement.add.namePlaceholder')"
            class="figma-form-input" />
        </el-form-item>
        <el-form-item label="性别:" prop="sex" required>
          <el-select v-model="addForm.sex" placeholder="请选择性别" class="figma-form-input" clearable>
            <el-option label="男" value="1" />
            <el-option label="女" value="0" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('userManagement.add.phone') + ':'" prop="tel" required>
          <el-input v-model="addForm.tel" :placeholder="$t('userManagement.add.phonePlaceholder')"
            class="figma-form-input" />
        </el-form-item>
        <el-form-item :label="$t('userManagement.add.email') + ':'" prop="email">
          <el-input v-model="addForm.email" :placeholder="$t('userManagement.add.emailPlaceholder')"
            class="figma-form-input" />
        </el-form-item>
        <el-form-item :label="$t('userManagement.add.password') + ':'" prop="password" required>
          <el-input v-model="addForm.password" type="password" show-password :placeholder="$t('userManagement.add.passwordPlaceholder')"
            class="figma-form-input" />
        </el-form-item>
        <el-form-item :label="$t('userManagement.add.idCard') + ':'" prop="idCard" :required="isAddIdCardRequired">
          <el-input v-model="addForm.idCard" :placeholder="$t('userManagement.add.idCardPlaceholder')"
            class="figma-form-input" />
        </el-form-item>
        <el-form-item :label="$t('userManagement.add.address') + ':'" prop="address">
          <el-input v-model="addForm.address" :placeholder="$t('userManagement.add.addressPlaceholder')"
            class="figma-form-input" />
        </el-form-item>
        <el-form-item :label="$t('userManagement.add.uploadImage') + ':'" prop="uploadImage">
          <upload-image-url
            ref="addUploadImage"
            :image-count="1"
            @notifyUploadCoverImage="handleAddUploadImage"
          />
        </el-form-item>
        <el-form-item :label="$t('userManagement.add.remark') + ':'" prop="remark">
          <el-input v-model="addForm.remark" :placeholder="$t('userManagement.add.remarkPlaceholder')"
            class="figma-form-input" />
        </el-form-item>
        <el-form-item :label="$t('userManagement.add.status') + ':'" prop="status">
          <div class="status-radio-wrap">
            <img src="/assets/CodeBuddyAssets/914_10296/29.svg" class="radio-icon" />
            <span class="radio-label">{{ $t('userManagement.status.normal') }}</span>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="figma-dialog-footer">
        <el-button size="small" class="figma-btn-cancel" @click="addDialogVisible = false">
          {{ $t('userManagement.add.cancel') }}
        </el-button>
        <el-button size="small" class="figma-btn-confirm" @click="_submitAdd">
          {{ $t('userManagement.add.confirm') }}
        </el-button>
      </div>
    </el-dialog>

    <!-- 编辑弹窗 -->
    <el-dialog :visible.sync="editDialogVisible" width="650px" :show-close="false"
      custom-class="figma-edit-dialog" @close="_resetEditForm">
      <div slot="title" class="figma-dialog-header">
        <span class="figma-dialog-title">{{ $t('userManagement.edit.title') }}</span>
        <img src="/assets/CodeBuddyAssets/914_10296/26.svg" class="dialog-divider" />
      </div>
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="84px"
        class="figma-edit-form" size="small">
        <el-form-item :label="$t('userManagement.edit.roleGroup') + ':'" prop="roleId" required>
          <el-select v-model="editForm.roleId" :placeholder="$t('userManagement.edit.roleGroupPlaceholder')"
            class="figma-form-input" clearable :disabled="editRoleLocked" @change="handleEditRoleChange">
            <el-option v-for="item in roleGroupOptions" :key="item.value"
              :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="isEditDistrictHousingBureauRole" :label="isEditCityHousingBureauRole ? '省市:' : '省市区:'" prop="provinceCode" required>
          <div class="area-cascader-row">
            <el-select v-model="editForm.provinceCode" placeholder="请选择省"
              class="area-cascader-select" disabled>
              <el-option v-for="item in areaOptions.provs" :key="item.areaCode"
                :label="item.areaName" :value="item.areaCode" />
            </el-select>
            <el-select v-model="editForm.cityCode" placeholder="请选择市"
              class="area-cascader-select" disabled>
              <el-option v-for="item in areaOptions.citys" :key="item.areaCode"
                :label="item.areaName" :value="item.areaCode" />
            </el-select>
            <el-select v-if="!isEditCityHousingBureauRole" v-model="editForm.districtCode" placeholder="请选择区"
              class="area-cascader-select" disabled>
              <el-option v-for="item in areaOptions.areas" :key="item.areaCode"
                :label="item.areaName" :value="item.areaCode" />
            </el-select>
          </div>
        </el-form-item>
        <el-form-item v-if="showEditCommunitySelect" label="所属小区:" prop="communityIds" required>
          <el-select v-model="editForm.communityIds" placeholder="请选择小区"
            class="figma-form-input" clearable multiple filterable :disabled="editRoleLocked">
            <el-option v-for="item in communityOptions" :key="item.value"
              :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('userManagement.edit.name') + ':'" prop="name" required>
          <el-input v-model="editForm.name" :placeholder="$t('userManagement.edit.namePlaceholder')"
            class="figma-form-input" />
        </el-form-item>
        <el-form-item label="性别:" prop="sex" required>
          <el-select v-model="editForm.sex" placeholder="请选择性别" class="figma-form-input" clearable>
            <el-option label="男" value="1" />
            <el-option label="女" value="0" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('userManagement.edit.phone') + ':'" prop="tel" required>
          <el-input v-model="editForm.tel" :placeholder="$t('userManagement.edit.phonePlaceholder')"
            class="figma-form-input" disabled />
        </el-form-item>
        <el-form-item :label="$t('userManagement.edit.email') + ':'" prop="email">
          <el-input v-model="editForm.email" :placeholder="$t('userManagement.edit.emailPlaceholder')"
            class="figma-form-input" />
        </el-form-item>
        <el-form-item :label="$t('userManagement.edit.password') + ':'" prop="password">
          <el-input v-model="editForm.password" type="password" show-password
            :placeholder="editPasswordExists ? '留空则不修改密码' : $t('userManagement.edit.passwordPlaceholder')"
            class="figma-form-input" />
          <div v-if="editPasswordExists" class="form-tip">当前密码已加密保存，如需修改请输入新密码</div>
        </el-form-item>
        <el-form-item :label="$t('userManagement.edit.idCard') + ':'" prop="idCard" :required="isEditIdCardRequired">
          <el-input v-model="editForm.idCard" :placeholder="$t('userManagement.edit.idCardPlaceholder')"
            class="figma-form-input" />
        </el-form-item>
        <el-form-item :label="$t('userManagement.edit.address') + ':'" prop="address">
          <el-input v-model="editForm.address" :placeholder="$t('userManagement.edit.addressPlaceholder')"
            class="figma-form-input" />
        </el-form-item>
        <el-form-item :label="$t('userManagement.edit.uploadImage') + ':'" prop="uploadImage">
          <upload-image-url
            ref="editUploadImage"
            :image-count="1"
            @notifyUploadCoverImage="handleEditUploadImage"
          />
        </el-form-item>
        <el-form-item :label="$t('userManagement.edit.remark') + ':'" prop="remark">
          <el-input v-model="editForm.remark" :placeholder="$t('userManagement.edit.remarkPlaceholder')"
            class="figma-form-input" />
        </el-form-item>
        <el-form-item :label="$t('userManagement.edit.status') + ':'" prop="status">
          <div class="status-radio-wrap">
            <img src="/assets/CodeBuddyAssets/914_10296/29.svg" class="radio-icon" />
            <span class="radio-label">{{ $t('userManagement.status.normal') }}</span>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="figma-dialog-footer">
        <el-button size="small" class="figma-btn-cancel" @click="editDialogVisible = false">
          {{ $t('userManagement.edit.cancel') }}
        </el-button>
        <el-button size="small" class="figma-btn-confirm" @click="_submitEdit">
          {{ $t('userManagement.edit.confirm') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listUserManagement, updateUserManagement, addUserManagement, deleteUserManagement, listRoleGroups, listHousingBureauStaffScopes } from '@/api/platform/platformApi'
import { listCommunitys, listAreas } from '@/api/community/communityManageApi'
import UploadImageUrl from '@/components/upload/UploadImageUrl'

export default {
  name: 'UserManagementList',
  components: {
    UploadImageUrl
  },
  data() {
    const validateCommunityIds = (roleGetter) => (rule, value, callback) => {
      if (roleGetter() && (!value || value.length === 0)) {
        callback(new Error(this.$t('userManagement.validate.communityRequired')))
        return
      }
      callback()
    }
    const validateIdCard = (roleGetter) => (rule, value, callback) => {
      if (roleGetter() && !value) {
        callback(new Error(this.$t('userManagement.validate.idCardRequired')))
        return
      }
      callback()
    }
    const validateAreaCode = (roleGetter) => (rule, value, callback) => {
      if (!roleGetter()) {
        callback()
        return
      }
      const levelCd = this.getHousingBureauLevel(this.getRoleOptionById(this.addForm.roleId))
      if (levelCd === '07') {
        // 市住建局：只需选择省+市（层级202）
        if (!value || !this.addForm.cityCode) {
          callback(new Error('请选择省市'))
          return
        }
      } else {
        // 区住建局：需选择省+市+区（层级303）
        if (!value || !this.addForm.cityCode || !this.addForm.districtCode) {
          callback(new Error('请选择省市区'))
          return
        }
      }
      callback()
    }
    return {
      conditions: { keyword: '', telLike: '', roleName: '' },
      tableData: [],
      pagination: { current: 1, size: 10, total: 0 },
      // 编辑弹窗
      editDialogVisible: false,
      editPasswordExists: false,
      editRoleLocked: false,
      editForm: {
        id: '',
        roleId: '',
        communityIds: [],
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        districtCode: '',
        districtName: '',
        tel: '',
        email: '',
        name: '',
        sex: '1',
        password: '',
        idCard: '',
        address: '',
        uploadImage: '',
        remark: '',
        status: '1'
      },
      editRules: {
        roleId: [{ required: true, message: this.$t('userManagement.validate.roleGroupRequired'), trigger: 'change' }],
        communityIds: [{ validator: validateCommunityIds(() => this.showEditCommunitySelect), trigger: 'change' }],
        idCard: [{ validator: validateIdCard(() => this.isEditIdCardRequired), trigger: 'blur' }],
        tel: [
          { required: true, message: this.$t('userManagement.validate.phoneRequired'), trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: this.$t('userManagement.validate.phoneFormat'), trigger: 'blur' }
        ],
        name: [{ required: true, message: this.$t('userManagement.validate.nameRequired'), trigger: 'blur' }]
      },
      // 新增弹窗
      addDialogVisible: false,
      addForm: {
        roleId: '',
        communityIds: [],
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        districtCode: '',
        districtName: '',
        tel: '',
        email: '',
        name: '',
        sex: '',
        password: '',
        idCard: '',
        address: '',
        uploadImage: '',
        remark: '',
        status: '1'
      },
      addRules: {
        roleId: [{ required: true, message: this.$t('userManagement.validate.roleGroupRequired'), trigger: 'change' }],
        communityIds: [{ validator: validateCommunityIds(() => this.showAddCommunitySelect), trigger: 'change' }],
        idCard: [{ validator: validateIdCard(() => this.isAddIdCardRequired), trigger: 'blur' }],
        provinceCode: [{ validator: validateAreaCode(() => this.isAddDistrictHousingBureauRole), trigger: 'change' }],
        tel: [
          { required: true, message: this.$t('userManagement.validate.phoneRequired'), trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: this.$t('userManagement.validate.phoneFormat'), trigger: 'blur' }
        ],
        name: [{ required: true, message: this.$t('userManagement.validate.nameRequired'), trigger: 'blur' }],
        password: [{ required: true, message: this.$t('userManagement.validate.passwordRequired'), trigger: 'blur' }]
      },
      roleGroupOptions: [],
      communityOptions: [],
      areaOptions: {
        provs: [],
        citys: [],
        areas: []
      }
    }
  },
  computed: {
    showAddCommunitySelect() {
      return this.isCommunityScopedRole(this.getRoleOptionById(this.addForm.roleId))
    },
    isAddIdCardRequired() {
      return this.isCommunityScopedRole(this.getRoleOptionById(this.addForm.roleId))
    },
    isAddDistrictHousingBureauRole() {
      return this.isHousingBureauRoleByOption(this.getRoleOptionById(this.addForm.roleId))
    },
    isAddCityHousingBureauRole() {
      return this.getHousingBureauLevel(this.getRoleOptionById(this.addForm.roleId)) === '07'
    },
    showEditCommunitySelect() {
      return this.isCommunityScopedRole(this.getRoleOptionById(this.editForm.roleId)) || this.editForm.communityIds.length > 0
    },
    isEditIdCardRequired() {
      return this.isCommunityScopedRole(this.getRoleOptionById(this.editForm.roleId))
    },
    isEditDistrictHousingBureauRole() {
      return this.isHousingBureauRoleByOption(this.getRoleOptionById(this.editForm.roleId))
    },
    isEditCityHousingBureauRole() {
      return this.getHousingBureauLevel(this.getRoleOptionById(this.editForm.roleId)) === '07'
    }
  },
  created() {
    this._listData(this.pagination.current, this.pagination.size)
    this._loadRoleGroups()
  },
  methods: {
    _listData(page, size) {
      listUserManagement({ ...this.conditions, page, row: size }).then(res => {
        let list = []
        if (Array.isArray(res)) {
          list = res
        } else if (Array.isArray(res.users)) {
          list = res.users
        } else if (Array.isArray(res.data)) {
          list = res.data
        } else if (Array.isArray(res.records)) {
          list = res.records
        }
        this.tableData = list
        this.pagination.total = res.total || list.length || 0
      }).catch(error => {
        console.error('请求失败处理', error)
      })
    },
    _queryMethod() {
      this.pagination.current = 1
      this._listData(this.pagination.current, this.pagination.size)
    },
    _loadRoleGroups() {
      // 平台端不按 storeId 过滤，获取所有角色组
      return listRoleGroups({ communityId: '-1' }).then(res => {
        // 接口直接返回数组，不是 { data: [...] } 结构
        const list = Array.isArray(res) ? res : (res.data || res.records || [])
        console.log('角色组原始数据:', list)
        this.roleGroupOptions = list.map(item => ({
          label: item.pgName || item.name || item.label || item.groupName || item.privilegeGroupName || item.roleGroupName || item.title || '-',
          value: String(item.pId || item.id || item.value || item.groupId || item.privilegeGroupId || item.roleGroupId || item.pgId || ''),
          raw: item
        }))
        console.log('角色组选项:', this.roleGroupOptions)
      }).catch(error => {
        console.error('获取角色组失败', error)
      })
    },
    _openAddDialog() {
      this._loadRoleGroups().then(() => {
        this.addForm = {
          roleId: '',
          communityIds: [],
          provinceCode: '',
          provinceName: '',
          cityCode: '',
          cityName: '',
          districtCode: '',
          districtName: '',
          tel: '',
          email: '',
          name: '',
          sex: '',
          password: '',
          idCard: '',
          address: '',
          uploadImage: '',
          remark: '',
          status: '1'
        }
        this.areaOptions.citys = []
        this.areaOptions.areas = []
        this.loadAreas('101', '0', 'provs')
        this.addDialogVisible = true
        this.$nextTick(() => {
          if (this.$refs.addUploadImage) {
            this.$refs.addUploadImage.clearImages()
          }
        })
      }).catch(() => {
        this.addDialogVisible = true
      })
    },
    _resetAddForm() {
      if (this.$refs.addForm) {
        this.$refs.addForm.resetFields()
      }
      this.addForm.uploadImage = ''
      this.areaOptions.citys = []
      this.areaOptions.areas = []
      if (this.$refs.addUploadImage) {
        this.$refs.addUploadImage.clearImages()
      }
    },
    handleAddRoleChange() {
      this.addForm.communityIds = []
      if (!this.isAddDistrictHousingBureauRole) {
        // 非区住建局角色清空省市区选择，避免残留数据
        this.addForm.provinceCode = ''
        this.addForm.provinceName = ''
        this.addForm.cityCode = ''
        this.addForm.cityName = ''
        this.addForm.districtCode = ''
        this.addForm.districtName = ''
        this.areaOptions.citys = []
        this.areaOptions.areas = []
      }
      if (this.showAddCommunitySelect) {
        this._loadCommunityOptions()
      }
      this.$nextTick(() => {
        if (this.$refs.addForm) {
          this.$refs.addForm.clearValidate('communityIds')
          this.$refs.addForm.clearValidate('idCard')
          this.$refs.addForm.clearValidate('provinceCode')
        }
      })
    },
    loadAreas(areaLevel, parentAreaCode, key) {
      return listAreas({ areaLevel, parentAreaCode }).then(res => {
        this.areaOptions[key] = res.areas || []
      }).catch(error => {
        console.error('查询地区失败', error)
        this.$message.error('查询地区失败')
      })
    },
    handleAddProvChange(value) {
      const current = this.areaOptions.provs.find(item => item.areaCode === value)
      this.addForm.provinceName = current ? current.areaName : ''
      this.addForm.cityCode = ''
      this.addForm.cityName = ''
      this.addForm.districtCode = ''
      this.addForm.districtName = ''
      this.areaOptions.citys = []
      this.areaOptions.areas = []
      if (value) this.loadAreas('202', value, 'citys')
    },
    handleAddCityChange(value) {
      const current = this.areaOptions.citys.find(item => item.areaCode === value)
      this.addForm.cityName = current ? current.areaName : ''
      this.addForm.districtCode = ''
      this.addForm.districtName = ''
      this.areaOptions.areas = []
      if (value) this.loadAreas('303', value, 'areas')
    },
    handleAddAreaChange(value) {
      const current = this.areaOptions.areas.find(item => item.areaCode === value)
      this.addForm.districtName = current ? current.areaName : ''
      this.$nextTick(() => {
        if (this.$refs.addForm) {
          this.$refs.addForm.validateField('provinceCode')
        }
      })
    },
    handleEditRoleChange() {
      this.editForm.communityIds = []
      if (this.showEditCommunitySelect) {
        this._loadCommunityOptions()
      }
      this.$nextTick(() => {
        if (this.$refs.editForm) {
          this.$refs.editForm.clearValidate('communityIds')
          this.$refs.editForm.clearValidate('idCard')
        }
      })
    },
    getRoleOptionById(roleId) {
      return this.roleGroupOptions.find(item => String(item.value) === String(roleId)) || null
    },
    isCommunityScopedRole(role) {
      if (!role) return false
      const text = [
        role.label,
        role.raw && role.raw.pgName,
        role.raw && role.raw.name,
        role.raw && role.raw.roleName,
        role.raw && role.raw.groupName,
        role.raw && role.raw.privilegeGroupName,
        role.raw && role.raw.roleGroupName,
        role.raw && role.raw.title
      ].filter(Boolean).join(' ').toLowerCase()
      return text.includes('业委会') || text.includes('物业员工') || text.includes('owner committee') || text.includes('property staff')
    },
    isOwnerCommitteeRoleByOption(role) {
      if (!role) return false
      const text = [
        role.label,
        role.raw && role.raw.pgName,
        role.raw && role.raw.name,
        role.raw && role.raw.roleName,
        role.raw && role.raw.groupName,
        role.raw && role.raw.privilegeGroupName,
        role.raw && role.raw.roleGroupName,
        role.raw && role.raw.title
      ].filter(Boolean).join(' ').toLowerCase()
      return text.includes('业委会') || text.includes('owner committee')
    },
    isHousingBureauRoleByOption(role) {
      if (!role) return false
      return !!this.getHousingBureauLevel(role)
    },
    getHousingBureauLevel(role) {
      if (!role) return ''
      const text = [
        role.label,
        role.raw && role.raw.pgName,
        role.raw && role.raw.name,
        role.raw && role.raw.roleName,
        role.raw && role.raw.groupName,
        role.raw && role.raw.privilegeGroupName,
        role.raw && role.raw.roleGroupName,
        role.raw && role.raw.title
      ].filter(Boolean).join(' ').toLowerCase()
      if (text.includes('市住建局')) return '07'
      if (text.includes('区住建局') || text.includes('housing bureau') || text.includes('housingbureau')) return '06'
      return ''
    },
    _loadCommunityOptions() {
      if (this.communityOptions.length > 0) return Promise.resolve(this.communityOptions)
      return listCommunitys({ page: 1, row: 1000 }).then(res => {
        const list = res.communitys || res.data || res.records || []
        this.communityOptions = list.map(item => ({
          label: this.getCommunityLabel(item),
          value: String(item.communityId || item.id || item.value || '')
        })).filter(item => item.value)
        return this.communityOptions
      }).catch(error => {
        console.error('获取小区列表失败', error)
        this.communityOptions = []
        return []
      })
    },
    getCommunityLabel(item) {
      return item.communityName || item.nameCn || item.cnName || item.chineseName || item.name || item.communityId || '-'
    },
    mergeCommunityOptions(communities) {
      const options = (communities || []).map(item => ({
        label: this.getCommunityLabel(item),
        value: String(item.communityId || item.id || item.value || '')
      })).filter(item => item.value)
      options.forEach(option => {
        const index = this.communityOptions.findIndex(item => String(item.value) === String(option.value))
        if (index === -1) {
          this.communityOptions.push(option)
        } else if (option.label && option.label !== '-') {
          this.$set(this.communityOptions, index, { ...this.communityOptions[index], label: option.label })
        }
      })
    },
    normalizeCommunityIds(value) {
      if (!value) return []
      const values = Array.isArray(value) ? value : String(value).split(',')
      return values.map(item => {
        if (item && typeof item === 'object') {
          return String(item.communityId || item.id || item.value || '')
        }
        return String(item || '').trim()
      }).filter(Boolean)
    },
    getRowCommunityIds(row) {
      return [
        ...this.normalizeCommunityIds(row.communityIds),
        ...this.normalizeCommunityIds(row.communityId),
        ...this.normalizeCommunityIds(row.communitys),
        ...this.normalizeCommunityIds(row.communities),
        ...this.normalizeCommunityIds(row.communityList)
      ].filter((item, index, list) => list.indexOf(item) === index)
    },
    normalizeUploadImage(value) {
      if (!value) return ''
      if (Array.isArray(value)) {
        return this.normalizeUploadImage(value[0])
      }
      if (typeof value === 'object') {
        return value.url || value.fileUrl || value.photoUrl || value.uploadImage || value.fileId || value.id || ''
      }
      return String(value).split(',').map(item => item.trim()).filter(Boolean)[0] || ''
    },
    getUserUploadImage(row) {
      const fields = [
        row.uploadImage,
        row.photoUrl,
        row.photo,
        row.avatar,
        row.headImg,
        row.headImage,
        row.fileUrl
      ]
      for (const field of fields) {
        const image = this.normalizeUploadImage(field)
        if (image) return image
      }
      return ''
    },
    getUserEmail(row) {
      const fields = [
        row.email,
        row.emailAddress,
        row.userEmail,
        row.mail,
        row.emailAddr
      ]
      for (const field of fields) {
        if (field !== undefined && field !== null && String(field).trim()) {
          return String(field).trim()
        }
      }
      return ''
    },
    hasStoredPassword(row) {
      const { hasPassword } = row || {}
      return hasPassword === true || hasPassword === 'true' || hasPassword === 'Y' || hasPassword === '1' || hasPassword === 1
    },
    syncUploadRef(refName, image) {
      this.$nextTick(() => {
        const uploader = this.$refs[refName]
        if (!uploader) return
        uploader.clearImages()
        if (image) {
          uploader.setImages([image])
        }
      })
    },
    handleAddUploadImage(images) {
      this.addForm.uploadImage = this.normalizeUploadImage(images)
    },
    handleEditUploadImage(images) {
      this.editForm.uploadImage = this.normalizeUploadImage(images)
    },
    _submitAdd() {
      this.$refs.addForm.validate(valid => {
        if (!valid) return
        const roleIds = this.addForm.roleId ? [this.addForm.roleId] : []
        let params
        if (this.isAddDistrictHousingBureauRole) {
          // 住建局账号：调用 user.saveUser（文档7.6），一次请求保存账号、角色和管辖区域
          // 后端自动设置 level_cd（06区/07市），并保存角色关系和 housing_bureau_staff_scope
          const levelCd = this.getHousingBureauLevel(this.getRoleOptionById(this.addForm.roleId))
          // 区住建局(06)使用 districtCode(层级303)，市住建局(07)使用 cityCode(层级202)
          const areaCode = levelCd === '07' ? this.addForm.cityCode : this.addForm.districtCode
          params = {
            userId: '-1',
            name: this.addForm.name,
            tel: this.addForm.tel,
            address: this.addForm.address,
            sex: this.addForm.sex,
            email: this.addForm.email,
            password: this.addForm.password,
            roleIds,
            housingBureauArea: { areaCode }
          }
        } else {
          // 其他角色：保持原有参数结构
          params = {
            name: this.addForm.name,
            tel: this.addForm.tel,
            email: this.addForm.email,
            sex: this.addForm.sex,
            password: this.addForm.password,
            address: this.addForm.address,
            levelCd: roleIds.length > 0 ? '00' : '',
            idCard: this.addForm.idCard,
            uploadImage: this.addForm.uploadImage,
            remark: this.addForm.remark,
            roleIds,
            provinceCode: this.addForm.provinceCode,
            provinceName: this.addForm.provinceName,
            cityCode: this.addForm.cityCode,
            cityName: this.addForm.cityName,
            districtCode: this.addForm.districtCode,
            districtName: this.addForm.districtName
          }
          if (this.showAddCommunitySelect) params.communityIds = this.addForm.communityIds
        }
        addUserManagement(params).then(() => {
          this.$message.success(this.$t('userManagement.add.success'))
          this.addDialogVisible = false
          this._queryMethod()
        }).catch(error => {
          this.$message.error(error && error.message ? error.message : error)
          console.error('新增失败', error)
        })
      })
    },
    _openEditDialog(row) {
      this._loadRoleGroups().then(() => {
        const firstRole = (row.roles && Array.isArray(row.roles) && row.roles.length > 0)
          ? row.roles[0]
          : null
        const roleId = firstRole
          ? String(firstRole.pId || firstRole.id || firstRole.value || firstRole.roleId || firstRole.pgId || '')
          : ''
        const selectedRoleOption = this.getRoleOptionById(roleId)
        const uploadImage = this.getUserUploadImage(row)
        this.editForm = {
          id: row.userId,
          roleId,
          communityIds: this.getRowCommunityIds(row),
          provinceCode: '',
          provinceName: '',
          cityCode: '',
          cityName: '',
          districtCode: '',
          districtName: '',
          tel: row.tel || '',
          email: this.getUserEmail(row),
          name: row.name || '',
          sex: row.sex || '',
          password: '',
          idCard: row.idCard || '',
          address: row.address || '',
          uploadImage,
          remark: row.remark || '',
          status: row.status || '1'
        }
        this.editRoleLocked = this.isCommunityScopedRole(selectedRoleOption) || this.isHousingBureauRoleByOption(selectedRoleOption)
        this.editPasswordExists = this.hasStoredPassword(row)
        this.mergeCommunityOptions(row.communitys || row.communities || row.communityList || [])
        this.editDialogVisible = true
        this.syncUploadRef('editUploadImage', uploadImage)
        if (this.isHousingBureauRoleByOption(selectedRoleOption)) {
          this._loadEditHousingBureauScope(row)
        } else if (this.showEditCommunitySelect) {
          this._loadCommunityOptions().then(() => {
            this.mergeCommunityOptions(row.communitys || row.communities || row.communityList || [])
          })
        }
      }).catch(() => {
        this.editDialogVisible = true
      })
    },
    _loadEditHousingBureauScope(row) {
      // 加载省列表，用于下拉显示
      this.loadAreas('101', '0', 'provs')
      // 查询人员管辖区域（文档7.8）
      listHousingBureauStaffScopes({ staffId: row.userId }).then(res => {
        const list = Array.isArray(res) ? res : (res.data || res.records || [])
        if (!list || list.length === 0) return
        const scope = list[0]
        this.editForm.provinceCode = scope.provinceCode || ''
        this.editForm.provinceName = scope.provinceName || ''
        this.editForm.cityCode = scope.cityCode || ''
        this.editForm.cityName = scope.cityName || ''
        this.editForm.districtCode = scope.districtCode || ''
        this.editForm.districtName = scope.districtName || ''
        // 加载市列表以显示市名称
        if (this.editForm.provinceCode) {
          this.loadAreas('202', this.editForm.provinceCode, 'citys').then(() => {
            // 区住建局还需加载区列表
            if (this.editForm.cityCode && !this.isEditCityHousingBureauRole) {
              this.loadAreas('303', this.editForm.cityCode, 'areas')
            }
          })
        }
      }).catch(error => {
        console.error('查询人员管辖区域失败', error)
      })
    },
    _resetEditForm() {
      if (this.$refs.editForm) {
        this.$refs.editForm.resetFields()
      }
      this.editRoleLocked = false
      this.editPasswordExists = false
      this.editForm.uploadImage = ''
      this.areaOptions.citys = []
      this.areaOptions.areas = []
      if (this.$refs.editUploadImage) {
        this.$refs.editUploadImage.clearImages()
      }
    },
    _submitEdit() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return
        const params = {
          userId: this.editForm.id,
          name: this.editForm.name,
          tel: this.editForm.tel,
          email: this.editForm.email,
          sex: this.editForm.sex,
          idCard: this.editForm.idCard,
          address: this.editForm.address,
          uploadImage: this.editForm.uploadImage,
          remark: this.editForm.remark,
          roleIds: this.editForm.roleId ? [this.editForm.roleId] : []
        }
        // 住建局账号不发送 levelCd，避免覆盖后端 level_cd（06/07）
        if (!this.isEditDistrictHousingBureauRole) {
          params.levelCd = this.editForm.roleId ? '00' : ''
        } else {
          // 住建局角色必须携带管辖区域编码（文档7.6/7.7），区域不可编辑时回传已加载的值
          // 市住建局(07)使用 cityCode(层级202)，区住建局(06)使用 districtCode(层级303)
          const areaCode = this.isEditCityHousingBureauRole
            ? this.editForm.cityCode
            : this.editForm.districtCode
          params.housingBureauArea = { areaCode }
        }
        if (this.showEditCommunitySelect) params.communityIds = this.editForm.communityIds
        if (this.editForm.password) {
          params.password = this.editForm.password
        }
        updateUserManagement(params).then(() => {
          this.$message.success(this.$t('userManagement.edit.success'))
          this.editDialogVisible = false
          this._listData(this.pagination.current, this.pagination.size)
        }).catch(error => {
          this.$message.error(error)
          console.error('编辑失败', error)
        })
      })
    },
    _deleteRow(row) {
      this.$confirm(this.$t('userManagement.delete.confirm'), this.$t('userManagement.delete.title'), {
        confirmButtonText: this.$t('userManagement.action.delete'),
        cancelButtonText: this.$t('userManagement.delete.cancel'),
        type: 'warning'
      }).then(() => {
        deleteUserManagement({ userId: row.userId }).then(() => {
          this.$message.success(this.$t('userManagement.delete.success'))
          this._queryMethod()
        }).catch(error => {
          console.error('删除失败', error)
        })
      }).catch(() => {})
    },
    getStatusClass(status) {
      return { '0': 'status-danger', '1': 'status-normal', '2': 'status-warning' }[status] || 'status-normal'
    },
    getRoleNames(roles) {
      if (!roles || !Array.isArray(roles) || roles.length === 0) return '-'
      return roles.map(r => r.roleName).join('、')
    },
    getStatusName(row) {
      if (row.statusName) return row.statusName
      // 根据 levelCd 推断状态显示
      return row.status === '0' ? this.$t('userManagement.status.disabled') : this.$t('userManagement.status.normal')
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this._listData(this.pagination.current, val)
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this._listData(val, this.pagination.size)
    },
    headerCellStyle() {
      return { background: '#EBF2FA', color: '#364153', fontSize: '14px', fontWeight: '500', fontFamily: 'PingFang SC' }
    },
    cellStyle({ row }) {
      const rowIndex = this.tableData.indexOf(row)
      return rowIndex % 2 === 1
        ? { background: '#F8FBFF', color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC' }
        : { background: 'white', color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC' }
    }
  }
}
</script>

<style scoped>
.admin-room-container { height: calc(100vh - 60px); background: #EBF2FA; padding: 0; overflow: hidden; box-sizing: border-box; display: flex; flex-direction: column; }
.figma-white-card { background: white; border-radius: 0 0 12px 12px; flex: 1; min-height: 0; display: flex; flex-direction: column; }
.figma-page-header { display: flex; flex-direction: column; align-items: flex-start; width: 100%; box-sizing: border-box; padding: 20px 0 0; gap: 12px; }
.figma-page-title { font-size: 16px; font-weight: 400; color: #1D2129; font-family: 'PingFang SC'; padding: 0 24px; box-sizing: border-box; }
.figma-header-divider { width: calc(100% - 48px); height: 1px; background: #DCE6F5; margin: 0 24px; }
.figma-header-row { display: flex; align-items: center; justify-content: space-between; width: 100%; padding: 0 24px; box-sizing: border-box; }
.figma-btn-group { display: flex; align-items: center; gap: 8px; }
.figma-btn-add { height: 38px; border-radius: 10px !important; background: #0E76FF !important; border: none !important; color: white !important; font-size: 14px; font-weight: 500; padding: 0 16px; display: inline-flex; align-items: center; gap: 6px; }
.figma-btn-add:hover { background: #0D6FE0 !important; }
.figma-btn-add .btn-icon { width: 14px; height: 14px; }
.figma-btn-refresh { height: 38px; width: 38px; border-radius: 10px !important; border: 1px solid #DCE6F5 !important; background: white !important; color: #6A7282 !important; display: inline-flex; align-items: center; justify-content: center; padding: 0; }
.figma-btn-refresh:hover { border-color: #0E76FF !important; color: #0E76FF !important; }
.figma-btn-refresh .btn-icon { width: 16px; height: 16px; }
.figma-search-group { display: flex; align-items: center; gap: 8px; margin-left: auto; }
.figma-search-input { width: 256px; height: 38px; }
.figma-search-input >>> .el-input__inner { border-radius: 10px; border: none; outline: 1px #DCE6F5 solid; outline-offset: -1px; height: 38px; font-size: 14px; background: white; }
.figma-search-input >>> .el-input__inner:focus { outline-color: #0E76FF; }
.figma-search-select { width: 180px; height: 38px; }
.figma-search-select >>> .el-input__inner { border-radius: 10px; border: none; outline: 1px #DCE6F5 solid; outline-offset: -1px; height: 38px; font-size: 14px; background: white; }
.figma-search-select >>> .el-input__inner:focus { outline-color: #0E76FF; }
.figma-btn-search { height: 38px; border-radius: 10px !important; border: none !important; outline: 1px #0E76FF solid !important; outline-offset: -1px; color: #0E76FF !important; background: white !important; font-size: 14px; font-weight: 500; padding: 0 16px; display: inline-flex; align-items: center; gap: 6px; }
.figma-btn-search:hover { background: rgba(14, 118, 255, 0.08) !important; }
.figma-btn-search .btn-icon { width: 14px; height: 14px; }
.figma-table-section { flex: 1; width: 100%; box-sizing: border-box; padding: 0 24px; margin-top: 12px; overflow: auto; }
.figma-table-section >>> .el-table { width: 100% !important; border-radius: 8px; overflow: hidden; border: none; }
.figma-table-section >>> .el-table__header th { background: #EBF2FA !important; border: none !important; }
.figma-table-section >>> .el-table__body td { border: none !important; border-bottom: 1px solid #F0F0F0 !important; }
.figma-table-section >>> .el-table__body tr:nth-child(even) td { background: #F8FBFF; }
.figma-phone { color: #0E76FF; font-size: 14px; }
.status-tag { display: inline-block; padding: 3px 12px; border-radius: 8px; font-size: 14px; font-weight: 400; }
.status-normal { background: rgba(33, 185, 86, 0.10); color: #21B956; outline: 1px solid #21B956; outline-offset: -1px; }
.status-danger { background: rgba(251, 44, 54, 0.10); color: #FB2C36; outline: 1px solid #FB2C36; outline-offset: -1px; }
.status-warning { background: rgba(255, 153, 0, 0.10); color: #FF9900; outline: 1px solid #FF9900; outline-offset: -1px; }
.action-links { display: inline-flex; align-items: center; justify-content: center; gap: 12px; width: 100%; white-space: nowrap; }
.action-link { display: inline-flex; align-items: center; justify-content: center; min-width: 28px; line-height: 20px; color: #0E76FF; font-size: 14px; cursor: pointer; text-decoration: none; }
.action-link:hover { text-decoration: underline; }
.action-link-danger { color: #FB2C36; }
.link-separator { display: none; }
.figma-pagination { display: flex; align-items: center; justify-content: flex-end; padding: 16px 24px; gap: 16px; border-top: 1px solid #DCE6F5; }
.pagination-total { font-size: 14px; color: #1D2129; }
.figma-pagination >>> .el-pagination { display: flex; align-items: center; }
.figma-pagination >>> .el-pager li { border-radius: 8px; }
.figma-pagination >>> .el-pager li.active { background: #E8F3FF; color: #0E76FF; }
.pagination-size-select { width: 92px; }
.pagination-size-select >>> .el-input__inner { border-radius: 8px; background: #F2F3F5; border: none; font-size: 14px; }

/* 弹窗样式 - 1:1还原Figma */
.figma-edit-dialog >>> .el-dialog { border-radius: 12px; overflow: hidden; }
.figma-edit-dialog >>> .el-dialog__header { padding: 0; }
.figma-edit-dialog >>> .el-dialog__body { padding: 0 24px; }
.figma-dialog-header { background: #EBF2FA; padding: 22px 24px; position: relative; }
.figma-dialog-title { font-size: 16px; font-weight: 600; color: #1D2129; font-family: 'PingFang SC'; }
.dialog-divider { position: absolute; left: 0; bottom: 0; width: 100%; height: 1px; }
.figma-edit-form { padding: 24px 0 0; }
.figma-edit-form >>> .el-form-item { margin-bottom: 20px; }
.figma-edit-form >>> .el-form-item__label { font-size: 14px; color: #1D2129; font-weight: 500; font-family: 'PingFang SC'; padding-right: 12px; text-align: right; }
.figma-edit-form >>> .el-form-item.is-required .el-form-item__label::before { color: #FB2C36; margin-right: 2px; }
.figma-form-input { width: 518px; }
.figma-form-input >>> .el-input__inner,
.figma-form-input >>> .el-select .el-input__inner { border-radius: 10px; border: none; outline: 1px #DCE6F5 solid; outline-offset: -1px; height: 38px; font-size: 14px; }
.figma-form-input >>> .el-input__inner:focus,
.figma-form-input >>> .el-select .el-input__inner:focus { outline-color: #0E76FF; }
.area-cascader-row { display: flex; align-items: center; gap: 8px; width: 518px; }
.area-cascader-select { flex: 1; min-width: 0; }
.area-cascader-select >>> .el-input__inner { border-radius: 10px; border: none; outline: 1px #DCE6F5 solid; outline-offset: -1px; height: 38px; font-size: 14px; }
.area-cascader-select >>> .el-input__inner:focus { outline-color: #0E76FF; }
.form-tip { margin-top: 8px; font-size: 12px; line-height: 18px; color: #8C9BB4; }
.status-radio-wrap { display: flex; align-items: center; gap: 8px; }
.status-radio-wrap .radio-icon { width: 24px; height: 24px; }
.status-radio-wrap .radio-label { font-size: 14px; color: #8C9BB4; font-family: 'PingFang SC'; font-weight: 500; }
.figma-dialog-footer { display: flex; justify-content: flex-end; gap: 12px; padding: 12px 24px 24px; }
.figma-btn-cancel { height: 38px; border-radius: 10px !important; border: 1px solid #0E76FF !important; background: white !important; color: #0E76FF !important; font-size: 14px; font-weight: 500; padding: 0 24px; }
.figma-btn-confirm { height: 38px; border-radius: 10px !important; background: #0E76FF !important; border: none !important; color: white !important; font-size: 14px; font-weight: 500; padding: 0 24px; }
</style>
